import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import Helmet from "react-helmet";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import Button from "@material-ui/core/Button";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import get from "lodash/get";
import noDataImage from "../../../../../../Assets/Images/undraw-security-o-890-1.png";
import emptylist from "../../../../../../Assets/Svg/illustration-no-policy.svg";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  List,
  TDTypeConsts,
  CreateComp,
} from "../../../../business-configration/commons";
import Create from "./create";
import Introduction from "./index1";
import CustomLoader from "Component/CustomLoader";


let CALLAPI = true;
class ExpensePolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      listdata: [],
      offset: 0,
      limit: 10,
      totalcount: 1,
      selectedPolicy: null,
      copypolicy: null,
      data: false,
      nofuel: false,
      emptyPage: null,
      headers: [
        {
          key: "policyname",
          name: "Policy Name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "codelimit",
          name: "Monthly Limit",
          type: TDTypeConsts.EXPENSE_MONTHLYLIMIT,
        },
        {
          key: "imagepath",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedemployee",
          name: "Assigned Employees",
          type: TDTypeConsts.ASSIGNED_USER,
        },
        {
          key: "edit1",
          name: "",
          type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        },
        {
          key: "delete",
          name: "",
          type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        },
      ],
    };

    this.getExpensePolicies = this.getExpensePolicies.bind(this);
    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onClosed = this.onClosed.bind(this);
  }

  componentWillMount() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  onClosed() {
    this.setState(
      {
        selectedData: null,
        // listdata: [],
        offset: 0,
        fullcount: 1,
        // offset: 0,
      },
      () => {
        this.getExpensePolicies(true);
        this.props.history.push(`${this.props.match.path}/list`);
      },
    );
  }

  handleScroll() {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom + 50 >= Math.floor(window.innerHeight * 0.65)) {
      this.getExpensePolicies();
    }
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("expensePolicy");
    if (isTrue) {
      this.setState({ permissions }, () => {
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        this.getExpenseCycleData();
        window.addEventListener("scroll", this.handleScroll);
        // this.getExpensePolicies();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getExpenseCycleData() {
    instance
      .get("expense/expensecycle")
      .then((result) => {
        this.setState({
          emptyPage: result.data.result,
          data: true,
        });
        if (get(result, "data.result[0].expenseconfigid", "")) {
          this.getExpensePolicies();
        } else {
          this.renderList();
          // this.props.enqueueSnackbar("Please configure Expense Cycle", { variant: "error" });
        }
      })
      .catch((error) => {
        this.setState({
          data: true,
        });
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getExpensePolicies(isrefresh = false) {
    if (CALLAPI) {
      if (this.state.offset < this.state.totalcount) {
        CALLAPI = false;
        this.setState({ isloading: true }, () => {


          instance
            .get(
              `expense/allexpensepolicy/${this.state.offset}/${this.state.limit}`,
            )
            .then((resp) => {
              CALLAPI = true;
              if (resp.data.result.length == 0) {
                instance
                  .get("expense/fuelpolicy")
                  .then((resp1) => {
                    if (resp1.data.result.length == 0) {
                      this.setState({
                        nofuel: true,
                      });
                    }
                  })
                  .catch((error) => {
                    const CommonError = error.response
                      ? error.response.data.error.message
                      : error.message;
                    this.props.enqueueSnackbar(CommonError, { variant: "error" });
                  });
              }

              const newdata = resp.data.result.map((x) => ({
                ...x,
                codelimit: `${this.props.SubscriptionInfo.SubscriptionData.currencycode
                  }${" "}${x.policylimit}`,
              }));
              this.setState({
                listdata: isrefresh
                  ? newdata
                  : [...this.state.listdata, ...newdata],
                totalcount: resp.data.result[0]
                  ? resp.data.result[0].fullcount
                  : 1,
                offset: this.state.offset + this.state.limit,
                isloading: false
              });
            });
        })
      }
    }
  }

  GetDefaultExpenseType() {
    return instance.get("expense/getexpensetype");
  }

  create() {
    return (
      !this.state.nofuel && (
        <Create
          {...this.props}
          {...this.state}
          getExpensePolicies={this.getExpensePolicies}
          onClosed={this.onClosed}
        />
      )
    );
  }

  async onCreate() {
    if (!this.state.nofuel) {
      const selectedPolicy = {
        expensepolicyid: 0,
        policyname: "",
        description: "",
        policylimittypeid: 1,
        policylimit: null,
        isreceiptnotrequire: false,
        receiptmaxamount: null,
        isallowedadvance: false,
        advanceamount: null,
        maxleftamount: null,
        isexceptionallowed: false,
        isdraft: false,
        category: [],
      };

      const result = await this.GetDefaultExpenseType();
      let DefaultExpenseCategories = [];
      if (result.data.result.length > 0) {
        DefaultExpenseCategories = result.data.result;
      }
      this.setState(
        {
          DefaultExpenseCategories,
          selectedExpenseType: DefaultExpenseCategories[0].expensetype,
        },
        () => {
          instance
            .get("expense/getexpensetypebypolicyid")
            .then((result1) => {
              selectedPolicy.category = result1.data.result[0].category;
              this.setState(
                {
                  newpolicycreate: true,
                  selectedPolicy,
                  copypolicy: JSON.stringify(selectedPolicy),
                },
                () => {
                  this.props.history.push(`${this.props.match.path}/create`);
                },
              );
            })
            .catch((error) => {
              const msg = error.response.data.error.message;
              this.props.enqueueSnackbar(msg, {
                variant: "error",
              });
            });
        },
      );
    } else {
      this.props.enqueueSnackbar("Please set fuel config first", {
        variant: "error",
      });
    }
  }

  async onEdit(item) {
    const result = await this.GetDefaultExpenseType();
    let DefaultExpenseCategories = [];
    if (result.data.result.length > 0) {
      DefaultExpenseCategories = result.data.result;
    }
    this.setState(
      {
        DefaultExpenseCategories,
        selectedExpenseType: DefaultExpenseCategories[0].expensetype,
      },
      () => {
        instance
          .get(`expense/getexpensetypebypolicyid/${item.expensepolicyid}`)
          .then((result1) => {
            const data = result1.data.result[0];
            data &&
              data.category &&
              (data.category = data.category.map((cat) => {
                const len = cat && cat.subcategory && cat.subcategory.length;
                const len1 =
                  cat && cat.subcategory
                    ? cat.subcategory.filter((sub) => sub.isselected)
                    : [];
                if (len != 0 && len == len1.length) {
                  return {
                    ...cat,
                    isselected: true,
                  };
                } else if (len != 0 && len != len1.length) {
                  return {
                    ...cat,
                    isselected: false,
                  };
                }
                return cat;
              }));
            this.setState({
              newpolicycreate: false,
              selectedPolicy: data,
              copypolicy: JSON.stringify(data),
            });
            this.setState({ editData: item }, () => {
              this.props.history.push(`${this.props.match.path}/create`);
            });
          })
          .catch((error) => {
            const msg = error.response.data.error.message;
            this.props.enqueueSnackbar(msg, {
              variant: "error",
            });
          });
      },
    );
  }

  onDelete(item) {
    instance.delete(`expense/expensepolicy/${item.expensepolicyid}`).then(
      () => {
        this.props.enqueueSnackbar("Expense policy successfully deleted.", {
          variant: "success",
        });
        this.setState(
          {
            selectedRow: null,
            createmenu: false,
            // listdata: [],
            offset: 0,
            totalcount: 1,
            backupList: [],

            data: [],
          },
          () => {
            this.getExpensePolicies(true);
          },
        );

        // this.props.closeSnakcbar();
      },
      (error) => {
        const msg = error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      },
    );
  }

  renderList() {
    // console.log("this.state.emptyPage.lengt: ", this.state.emptyPage.length);
    return (
      <div>
        {this.state.emptyPage && this.state.emptyPage.length > 0 ? (
          <div>
            {this.state.isloading ?
              <div>
                <CustomLoader />
              </div>
              : <div>
                {this.state.listdata && this.state.listdata.length > 0 ? (
                  <div className="content-outer-wrapper" onScroll={this.handleScroll}>
                    
                      <List
                        onCreate={this.onCreate}
                        list={this.state.listdata}
                        headers={this.state.headers}
                        permissions={this.state.permissions}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        module="expense policie"
                      />
                  
                  </div>
                ) : (
                  <div className="content-outer-wrapper">
                    <CreateComp
                      text="Create your first policy to get started"
                      heading="There are no policies to display yet!"
                      onCreate={this.onCreate}
                      imageSrc={emptylist}
                      permissions={this.state.permissions}
                    />
                  </div>
                )}
              </div>
            }
          </div>
        ) : (
          //   <div>
          //     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
          //       <img src={noDataImage} alt="image"></img>
          //       <p className="large-text-dark">Expense policy is currently locked</p>
          //       <p classNAme="normal-dark-secondary">Kindly configure your expense cycle before creating your policy.</p>
          //       <Button
          //         className="btn btn-primary-lg-blue"
          //         color="primary"
          //         variant="contained"
          //         onClick={() => this.props.history.push("/config/pay/expense/expense_cycle")}
          //       >
          //         Go to expense cycle
          // </Button>
          //     </div>
          //   </div>
          <div className="content-outer-wrapper">
            <div
              className="position-rel"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <DefaultComp
                heading={"Expense policy is currently locked."}
                subheading="Kindly configure your expense cycle before creating your policy."
                imageSrc={noDataImage}
              />
              <Button
                className="btn btn-primary-lg-blue"
                color="primary"
                variant="contained"
                style={{ width: 250, marginTop: 32 }}
                onClick={() =>
                  this.props.history.push("/config/pay/expense/expense_cycle")
                }
              >
                Go to expense cycle
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          <div>
            <Helmet>
              <title>{headersList.Config.ExpensePolicy.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div>
                {this.state.data && (
                  <div>
                    {/* <Route
                  exact
                  path={`${match.path}/create`}
                  render={this.create}
                /> */}
                    <div>
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}`}
                          render={this.renderList}
                        />
                        <Route
                          exact
                          path={`${match.path}/create`}
                          render={this.create}
                        />
                        <Redirect from={`${match.path}`} to={`${match.path}`} />
                      </Switch>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ExpensePolicy)),
);
